enum TicketFilters {
    Ticket = "Ticket",                          
    Status = "Status",
    Type = "Type",
    LastUpdateFrom = "LastUpdateFrom",
    Supplier = "Supplier",
    Group = "Group",
    Reporter = "Reporter",
    Assignee = "Assignee",
    CSAssignee = "CSAssignee",
    ServiceOrder = "ServiceOrder",
    CustomerOrder = "CustomerOrder",
    ProductSKU = "ProductSKU",
    Customer = "Customer",
    SerialNumber = "SerialNumber"
}

export default TicketFilters;